import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { getMAJAD020, postMAJAD020IpgumCheck } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_STATISTICAL } from '../../../shared/constants/app';
registerLocale('ko', ko);

const MAJAD020 = () => {
    const today = moment().toDate();
    const [date, setDate] = useState(moment().toDate());
    const [paymentsDJ, setPaymentsDJ] = useState([]);
    const [paymentsDA, setPaymentsDA] = useState([]);
    const handleDateChange = (date) => {
        const dateFormat = date ? moment(date).format('YYYY/MM/DD') : moment().subtract(1, 'day').format('YYYY/MM/DD');
        setDate(dateFormat);
    };

    const getListData = () => {
        const dateFormat = date ? moment(date).format('YYYYMMDD') : null;
        getMAJAD020(dateFormat)
            .then((data) => {
                setPaymentsDJ(data.data.paymentsDJ);
                setPaymentsDA(data.data.paymentsDA);
            })
            .catch((error) => console.log(error));
    };

    const handleIpgumCheck = (pSeq, memberID, rSeq) => {
        postMAJAD020IpgumCheck({ pSeq, memberID, rSeq, checkDate: moment(date).format('YYYY-MM-DD') })
            .then((data) => {
                window.alert("입금 확인이 되었습니다.");
                getListData();
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [date]);
    return (
        <div className="statis-page">
            <div className="container">
                <div className="content wrap">
                    <SideMenu menu={MENU_STATISTICAL} />
                    <div className=" content-right" style={{ width: 'calc(100% - 180px' }}>
                        <div className="title">무통장입금</div>
                        <div>
                            <table className="table-gray">
                                <tbody>
                                    <tr>
                                        <th style={{ width: 150 }}>일자</th>
                                        <td colSpan={3} style={{ textAlign: 'left' }}>
                                            <DatePicker
                                                style={{ width: 200 }}
                                                onChange={(date) => handleDateChange(date, 'date')}
                                                locale="ko"
                                                placeholderText="YYYY/MM/DD"
                                                dateFormat="yyyy/MM/dd"
                                                selected={date}
                                                maxDate={today}
                                                showYearDropdown
                                                showMonthDropdown
                                                scrollableYearDropdown
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="group-button center"></div>
                        </div>
                        <div className="table-padding-5 last-transparent">
                            <div className="table-wrap">
                                <table className="table-gray">
                                    <thead>
                                        <tr>
                                            <th />
                                            <th>pSeq</th>
                                            <th>Seq</th>
                                            <th>MemberID</th>
                                            <th>BizCompany</th>
                                            <th>NameKor</th>
                                            <th style={{ minWidth: '150px' }}>GoodName</th>
                                            <th>TotPrice</th>
                                            <th>BuyerCompany</th>
                                            <th>BuyerName</th>
                                            <th style={{ minWidth: '110px' }}>AddDate</th>
                                            <th style={{ whiteSpace: 'nowrap' }}>입금자명</th>
                                            <th style={{ whiteSpace: 'nowrap' }}>(가상)입금은행</th>
                                            <th>가상계좌</th>
                                            <th style={{ whiteSpace: 'nowrap' }}>(가상)입금자명</th>
                                            <th>계좌만료일</th>
                                            <th>TID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paymentsDJ &&
                                            paymentsDJ.length > 0 &&
                                            paymentsDJ.map((item, index) => {
                                                return (
                                                    <tr key={`payment-${index}`}>
                                                        <td
                                                            className="pointer"
                                                            onClick={() =>
                                                                handleIpgumCheck(item.pseq, item.memberID, item.seq)
                                                            }
                                                        >
                                                            선택
                                                        </td>
                                                        <td>{item.seq}</td>
                                                        <td>{item.pseq}</td>
                                                        <td>{item.memberID}</td>
                                                        <td>{item.bizCompany}</td>
                                                        <td>{item.nameKor}</td>
                                                        <td>{item.goodName}</td>
                                                        <td>{item.totPrice}</td>
                                                        <td>{item.buyerCompany}</td>
                                                        <td>{item.buyerName}</td>
                                                        <td>{moment(item.addDate).format('YYYY-MM-DD a hh:mm:ss')}</td>
                                                        <td>{item.vactInputName}</td>
                                                        <td>{item.vactBankCode}</td>
                                                        <td>{item.vactNum}</td>
                                                        <td>{item.virtualDepositorName}</td>
                                                        <td>{item.vactDate}</td>
                                                        <td>
                                                            <span>{item.tid}</span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        {paymentsDA &&
                                            paymentsDA.length > 0 &&
                                            paymentsDA.map((item, index) => {
                                                return (
                                                    <tr key={`payment-${index}`}>
                                                        <td>선택</td>
                                                        <td>{item.seq}</td>
                                                        <td>{item.pseq}</td>
                                                        <td>{item.memberID}</td>
                                                        <td>{item.bizCompany}</td>
                                                        <td>{item.nameKor}</td>
                                                        <td>{item.goodName}</td>
                                                        <td>{item.totPrice}</td>
                                                        <td>{item.buyerCompany}</td>
                                                        <td>{item.buyerName}</td>
                                                        <td>{moment(item.addDate).format('YYYY-MM-DD a hh:mm:ss')}</td>
                                                        <td>{item.vactInputName}</td>
                                                        <td>{item.vactBankCode}</td>
                                                        <td>{item.vactNum}</td>
                                                        <td>{item.virtualDepositorName}</td>
                                                        <td>{item.vactDate}</td>
                                                        <td>
                                                            <span>{item.tid}</span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAJAD020;
